export const ERROR_TYPE = {
	NO_DEVICE_ID: "E10005",
	FIRE_WATER_TANK_ERROR: "FIRE_TRAP_REG170_BIT2"
}